module.exports = __webpack_public_path__ + "static/img/23-WBB.35e83d5.png";


//////////////////
// WEBPACK FOOTER
// ./static/Icon/23-WBB.png
// module id = 0MXf
// module chunks = 1